import React from "react";

const CurrencyConverterSkeleton = () => {
  return (
    <div className="animate-pulse w-full space-y-6">

      {/* Row 1: You Send + They Receive (inside one card) */}
      <div className="bg-white shadow-lg rounded-3xl w-full p-6">
        <div className="flex flex-col md:flex-row justify-between items-stretch gap-4">
          {/* Left Column: You Send */}
          <div className="w-full md:w-[45%] space-y-2">
            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-1/3 mt-4"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>

          {/* Middle Column: Switch Icon */}
          <div className="w-full md:w-[10%] flex items-center justify-center">
            <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
          </div>

          {/* Right Column: They Receive */}
          <div className="w-full md:w-[45%] space-y-2">
            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-1/3 mt-4"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>
        </div>
      </div>

      {/* Row 2: Two separate cards */}
      <div className="flex flex-col md:flex-row gap-6">
        {/* Balance Summary */}
        <div className="w-full md:w-1/2 bg-white shadow-lg rounded-3xl p-6 space-y-4">
          <div className="h-5 bg-gray-300 rounded w-1/3"></div>
          <div className="h-6 bg-gray-300 rounded w-2/3"></div>
          <div className="h-5 bg-gray-300 rounded w-1/3 mt-4"></div>
          <div className="h-6 bg-gray-300 rounded w-2/3"></div>
        </div>

        {/* Recent Conversions */}
        <div className="w-full md:w-1/2 bg-white shadow-lg rounded-3xl p-6 space-y-4">
          <div className="flex justify-between items-center">
            <div className="h-5 bg-gray-300 rounded w-1/2"></div>
            <div className="h-5 bg-gray-300 rounded w-1/4"></div>
          </div>

          <div className="space-y-4 mt-4">
            {[...Array(2)].map((_, i) => (
              <div
                key={i}
                className="flex items-center justify-between bg-gray-100 rounded-xl p-4"
              >
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-white"></div>
                  <div className="h-4 bg-gray-300 rounded w-16"></div>
                </div>
                <div className="w-5 h-5 bg-gray-300 rounded"></div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-white"></div>
                  <div className="h-4 bg-gray-300 rounded w-16"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyConverterSkeleton;
